import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  BorderStyle,
  Color,
  CSSKeywords,
  Display,
  FontFamily,
  Icon,
  IconVariant,
  Text,
  Space,
} from '@gousto-internal/citrus-react'

import { DeliveryDay } from 'routes/Signup/Components/Calendar/models/DeliveryDay'

import { getDaysUntilDate } from './utils/utils'

type DeliveryInfoBannerProps = {
  deliveryDays: DeliveryDay[]
}

export function DeliveryInfoBanner({ deliveryDays }: DeliveryInfoBannerProps) {
  const availableDeliveryDays = deliveryDays.filter((dd) => dd.disabled === false)

  const earliestDeliveryDate = availableDeliveryDays[0].date

  const days = getDaysUntilDate(earliestDeliveryDate)

  if (!Number.isInteger(days)) {
    return null
  }

  return (
    <Box
      alignItems={AlignItems.Center}
      bg={Color.Informative_50}
      borderColor={Color.Informative_200}
      borderStyle={BorderStyle.Solid}
      borderWidth={0.5}
      borderRadius={1.5}
      data-testid="delivery-info-banner"
      display={Display.Flex}
      paddingV={4}
      paddingH={4}
    >
      <Icon name="delivery" variant={IconVariant.Informative} />
      <Space direction="horizontal" size={2} />
      <Body2 color={Color.ColdGrey_800}>
        to get{' '}
        <Text display={Display.Inline} fontFamily={FontFamily.Bold} size={CSSKeywords.Inherit}>
          your meals in as little as {days} days
        </Text>
      </Body2>
    </Box>
  )
}
